import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { fetchAuthSession } from "aws-amplify/auth";

// TODO set this correctly
const graphQLUrl = import.meta.env.VITE_GRAPHQL_URL;
// const graphQLUrl = "http://127.0.0.1:3001/api/graphql"; // local env

const httpLink = createHttpLink({ uri: graphQLUrl });

const authLink = setContext(async (_, { headers }) => {
  const session = await fetchAuthSession();
  const token = session?.tokens?.accessToken.toString();

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const graphQLClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: authLink.concat(httpLink),
});

export default graphQLClient;
